import {SetUsernameComponent} from './SetUsernameComponent';
import {UsernameContainerComponent} from './UsernameContainerComponent';
import {UsernameDialogComponent} from './UsernameDialogComponent';

export let loginUsernameModule = angular.module('authentication.login.username', []);

loginUsernameModule.component('setUsernameComponent', SetUsernameComponent);
loginUsernameModule.component('usernameContainerComponent', UsernameContainerComponent);
loginUsernameModule.component('usernameDialogComponent', UsernameDialogComponent);